import classNames from "classnames";
import { AndroidIcon, IosIcon } from "../../AscIcons";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { AscRichTextViewer, AscLink } from "@ascendnow/ascend-components";
import styles from "./AscAppCard.module.scss";

export interface AscAppCardProps {
  title: string;
  logoUrl?: string;
  description: string;
  loading?: boolean;
  androidLink?: string;
  iosLink?: string;
  ios?: boolean;
  android?: boolean;
  free?: boolean;
}

export default function AscAppCard({
  title,
  logoUrl,
  description,
  iosLink,
  ios = false,
  android = false,
  free = false,
  loading = false,
  androidLink,
}: AscAppCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground)}
      loading={loading}
      imageClassName={styles.cardImage}
      title={title}
      titleClassName={styles.cardTitle}
      coverImageUrl={logoUrl}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
    >
      <AscRichTextViewer
        inferValue={description}
        editorInputClass={styles.description}
      />
      <div className={styles.badges}>
        {(ios || android) && (
          <AscLink
            target="_blank"
            innerWrapperTag={null}
            href={iosLink || androidLink}
            className={styles.card}
          >
            Link to resource
          </AscLink>
        )}
        {/* {android ? (
          <AscLink
            target="_blank"
            innerWrapperTag={null}
            href={androidLink}
            className={styles.card}
          >
            <AndroidIcon
              data-testid="asc-app-card-android-icon"
              className={styles.cardIcon}
            />
          </AscLink>
        ) : null} */}
        {free ? (
          <div className={styles.card}>
            <span
              data-testid="asc-app-card-free-icon"
              className={styles.cardText}
            >
              Free
            </span>
          </div>
        ) : null}
      </div>
    </AscGenericCard>
  );
}
